var angular = require('angular');
var _module = require('./index');
const numAbbr = require('number-abbreviate');

_module
    .filter('twoLineAddress', ['$sce', function($sce) {
        return function(str) {
            return $sce.trustAsHtml(String(str).replace(/^([\w\s\d#.-]*)(,)/i, '$1<br>'));
        };
    }])

    .filter('twoLineAddressBoldVariant', ['$sce', function($sce) {
        return function(str) {
            return $sce.trustAsHtml(String(str).replace(/^([\w\s\d#.-]*)(,)/i, '$1<br>'));
        };
    }])

    .filter('addCommasToNumber', function() {
        return function(str) {  
            return String(str || '').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        };
    })

    .filter('formatPhoneNumber', function() {
        return function(phone) {
            return String(phone).replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        };
    })

    .filter('numberAbbreviate', function numberAbbreviate() {
        return function(num, minThreshold, precision) {
            if(!minThreshold) minThreshold = 1000000;
            if(!precision) precision = 1;
            if(isNaN(parseInt(num, 10))) return num;
            const n = parseInt(num);
            return numAbbr(num, (n >= minThreshold ? precision : 0));
        };
    })

    .filter('trustHtml', ['$sce', function($sce) {
        return function(str) {
            return $sce.trustAsHtml(String(str));
        };
    }])

    .filter('fixHtmlChars', function () {
        return function (str) {
            return angular.element('<div />').html(str).text();
        };
    })
    .filter('absoluteUrl', function () {
        return function (input) {
            var lowercase_input = String(input).toLowerCase();

            if(!(lowercase_input.substr(0, 7) === 'http://' || lowercase_input.substr(0, 8) === 'https://')) {
                input = 'http://' + input;
            }

            return input;
        };
    })

    .filter('thumborizeUrl', function() {
        return function(str, dims) {
            if(str && str.length && str.substr(0, 4) === 'http') {
                str = [
                    'https://d1u2xbew1ldorh.cloudfront.net',
                    '/unsafe/',
                    dims || '400x',
                    '/smart/',
                    encodeURIComponent(str)
                ].join('');
            }
            return str;
        };
    })
    .filter('firstName',function(){
        return function(input){
            var output = input.split(' ');
            return output[0];
        }
    })
;
